export const entitlementsTxt = {
  EXTENDED_METRIC_AMORTIZED_COST_SAVINGS:
    "Amortized Cost and Amortized Savings metrics are available at the Navigator Standard tier or above.",
  CREAT_ATTRIBUTION_GROUPS:
    "Create Attribution Groups are not available at your current tier, please contact your administrator to upgrade your tier.",
};
